/**
 * Cart modal (mini-cart hover) logic.
 * Extracted from jkl-header.liquid inline script for performance.
 */
(function () {
  var cartButton = document.querySelector(".card-drawer-button");
  var modal = document.getElementById("mini-cart-modal");
  if (!cartButton || !modal) return;

  var modalBody = document.getElementById("mini-cart-modal-body");
  var modalBottom = document.getElementById("mini-cart-modal-bottom");

  function openCartModal() {
    var cartDrawer = document.getElementById("cart-drawer");

    if (cartDrawer) {
      var free_shipping_bar = cartDrawer.querySelector(
        ".card-drawer__content .free-shipping-bar__content",
      );

      var inner =
        cartDrawer.querySelector(".cart-drawer__line-items") ||
        cartDrawer.querySelector(".empty-state");

      // Don't show the modal if cart is empty
      var items = inner ? inner.querySelectorAll("line-item") : null;
      if (!items || items.length === 0) {
        return false;
      }

      if (inner) {
        if (items) {
          modalBody.innerHTML = "";
          items.forEach(function (item) {
            var div = document.createElement("div");
            div.classList.add("card-drawer__line-item");
            div.innerHTML = item.innerHTML;
            modalBody.appendChild(div);
          });

          if (free_shipping_bar) {
            var div = document.createElement("div");
            div.classList.add("card-drawer__free-shipping-bar__content");
            div.innerHTML = free_shipping_bar.innerHTML;
            modalBody.appendChild(div);
          }
        } else {
          var cloned = inner.cloneNode(true);
          modalBody.innerHTML = cloned.outerHTML;
        }

        modalBottom.innerHTML = "";
        var origBottom = cartDrawer.querySelector(".cart-drawer__bottom");
        var origForm = cartDrawer.querySelector("form.buy-buttons");
        if (origBottom) modalBottom.appendChild(origBottom.cloneNode(true));
        if (origForm) modalBottom.appendChild(origForm.cloneNode(true));
      } else {
        modalBody.innerHTML = '<div style="padding:2rem;">Loading...</div>';
        modalBottom.innerHTML = "";
      }
    } else {
      modalBody.innerHTML = '<div style="padding:2rem;">Loading...</div>';
      modalBottom.innerHTML = "";
    }
    if (
      !document
        .querySelector("cart-notification-drawer")
        .classList.contains("show-close-cursor")
    ) {
      modal.style.display = "flex";
    }
    return true;
  }

  function closeCartModal() {
    modal.style.display = "none";
    cartButton.classList.remove("active");
  }

  modal.addEventListener("mouseleave", closeCartModal);

  cartButton.addEventListener("mouseover", function (e) {
    e.preventDefault();
    if (openCartModal()) {
      cartButton.classList.add("active");
    }
  });

  document.addEventListener("cart:change", function () {
    setTimeout(function () {
      openCartModal();
    }, 1251);
  });
})();
